@if (imageUrl) {
  <div>
    <div class="chat-message-image-container">
      <img class="image-preview" [src]="imageUrl" alt="Agent image" (click)="onOpenImage()">
    </div>
  </div>
}

@if (isImagePreviewOpen) {
  <app-file-preview-popup
    [files]="previewFiles"
    [startIndex]="0"
    [isMobileApp]="isMobileApp"
    [isCCU]="isCCU"
    (closed)="closeImagePreview()">
  </app-file-preview-popup>
}